var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recipient-address"},[_c('div',{staticClass:"recipient-address-item"},[_c('span',{staticClass:"recipient-address-title"},[_vm._v(_vm._s(_vm.itemInfo.title))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.itemInfo.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }